import { getContext } from '@/context';

const API_URL =
  process.env.REACT_APP_API_URL ||
  process.env.NEXT_PUBLIC_API_URL ||
  process.env.API_URL ||
  'https://api.picsart.com';
const UPLOAD_API_URL =
  process.env.REACT_APP_UPLOAD_URL || 'https://upload-stage.picsartstage2.com';
const REFRESH_TOKEN_URL = `${API_URL}/oauth2/refresh`;
const UNAUTHORIZED_STATUS_CODE = 401;

const backupFetch = window.fetch;

window.fetch = async (
  input: RequestInfo | URL,
  init?: RequestInit | undefined
) => {
  const context = getContext();

  // if not logged in, bypass
  if (!context.general.auth.getState().id) return backupFetch(input, init);

  const isRequestObjectUsed = input instanceof Request;

  // destructing the request url
  const url = isRequestObjectUsed ? input.url : input.toString();

  if (url.includes(API_URL) || url.includes(UPLOAD_API_URL)) {
    // executing actual request to the backend service
    const actualRequest = backupFetch(input, init);

    const result = await actualRequest;

    // trying to refresh the token on unauthorized status code
    if (
      !result.ok &&
      result.status === UNAUTHORIZED_STATUS_CODE &&
      !result.url.includes(REFRESH_TOKEN_URL)
    ) {
      if (
        getContext().utils.api.getHeaders()?.Authorization ===
        (init?.headers as Record<string, string>)?.Authorization
      ) {
        await context.handlers.refreshToken();
      }

      const headers = getContext().utils.api.getHeaders() as Record<
        string,
        string
      >;
      return backupFetch(input, {
        ...init,
        headers: { ...init?.headers, Authorization: headers.Authorization },
      });
    }

    // if the request is successful, we will not try to refresh the access token
    return result;
  }

  // if is not from our backend service bypass
  return backupFetch(input, init);
};
